import type { EventCategory } from './base';

type FoodWastePeriodProperty = 'this-month' | 'last-month' | 'ytd' | 'all' | 'custom';
type Scope = 'all' | 'one';

export const FoodWasteEvents = {
  FOOD_WASTE_CALCULATOR_VIEWED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      period: 'this-month' as FoodWastePeriodProperty,
      canteen_scope: 'all' as Scope,
      company_scope: 'all' as Scope,
    },
  },
  FOOD_WASTE_ASSUMPTION_CHANGED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      assumption: 'rate' as 'rate' | 'weight' | 'cost' | 'co2',
      value: 0 as number,
      is_default: false as boolean,
    },
  },
  FOOD_WASTE_PDF_DOWNLOADED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      period: 'this-month' as FoodWastePeriodProperty,
      canteen_scope: 'all' as Scope,
      company_scope: 'all' as Scope,
      buckets: 0 as number,
    },
  },
} as const;
